import { useState } from 'react';
import { Crown } from 'lucide-react';

interface CampaignArtworkProps {
  src: string;
  alt: string;
  className?: string;
  compact?: boolean;
}

/** The approved poster keeps its complete composition, including embedded text. */
export function CampaignArtwork({ src, alt, className = '', compact = false }: CampaignArtworkProps) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return <div className={`super-hero-art-fallback ${className}`} role="img" aria-label={alt}>
      <Crown aria-hidden="true" />
      {!compact && <span>EL GATO ×<br /><strong>SUPER HERO</strong></span>}
    </div>;
  }

  return <img src={src} alt={alt} className={className} onError={() => setFailed(true)} decoding="async" />;
}
